// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --inventory-bannder-height: 300px;
}

.inventory-header-start-section {
    min-height: var(--inventory-bannder-height);
    background: var(--bg-blue) 0% 0% no-repeat padding-box;
    color: var(--neutral-color1);
    width: 100%;
}

.wrapper-inventory-header-section {
    width: 100%;
    min-height: var(--inventory-bannder-height);
    padding: var(--body-header-padding);
}

.admin-inventory-header-start-section,
.admin-inventory-header-start-section .wrapper-inventory-header-section {
    min-height: calc(var(--inventory-bannder-height) - 100px);
}

.mutebtn{
    background-color: #A6D5EA !important;
}

.inventory-header-pill-section {
    width: 100%;
    display: grid;
    justify-items: center;
}

.inventory-header-pill-section .nav-responsive {
    max-width: 300px;
}

.inventory-header-search-group-section {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    margin-top: 20px;
}

.wrapper-inventory-header-search-group {
    min-height: 142px;
    background: var(--neutral-color1) 0% 0% no-repeat padding-box;
    border-radius: 6px;
    box-shadow: 0px 0px 6px var(--border-shadow-color3);
    padding: 18px 31px 21px;
    display: grid;
    transition: all 0.7s;
    grid-row-gap: 10px;
    color: var(--neutral-color7);
}

.wrapper-inventory-header-search-group .inventory-header-search-group-row-section:first-child {
    /* display: grid;
    grid-template-columns: 2fr 2fr 5fr; */
    display: flex;
    column-gap: 20px;
    align-items: center;
}

.wrapper-inventory-header-search-group .inventory-header-search-group-row-section:first-child .inventory-header-search-inner-group:first-child {
    font: normal normal 300 26px/32px Lato;
    letter-spacing: 0.26px;
    cursor: default;
}

.wrapper-inventory-header-search-group .inventory-header-search-group-row-section:first-child .inventory-header-search-inner-group .custom-control-label {
    font: normal normal 14px/17px Lato;
    letter-spacing: 0.14px;
}

.wrapper-inventory-header-search-group .inventory-header-search-group-row-section:first-child .inventory-header-search-inner-group .custom-control {
    display: grid;
    align-items: center;
}

.wrapper-inventory-header-search-group .inventory-header-search-group-row-section:last-child {
    display: grid;
    grid-template-columns: 1.4fr 1.2fr 0.1fr 2.4fr 1fr;
    align-items: center;
    grid-column-gap: 10px;
    max-height: 56px;
}

.wrapper-inventory-header-search-group .inventory-header-search-group-row-section:last-child .inventory-search-group-section:last-child {
    height: 56px;
    background: var(--call-to-action1) 0% 0% no-repeat padding-box;
    border-radius: 26px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font: normal normal bold 16px/19px Lato;
    letter-spacing: 0.16px;
    color: var(--neutral-color1);
    transition: all 0.5s;
}

.wrapper-inventory-header-search-group .inventory-header-search-group-row-section:last-child .inventory-search-group-section:last-child:hover {
    background-color: var(--call-to-action2);
    transition: all 0.5s;
}

.wrapper-inventory-header-search-group .inventory-header-search-group-row-section:last-child .inventory-search-group-section:last-child svg {
    margin-right: 10px;
}



.track-stock-pill-active .inventory-header-search-group-row-section:last-child {
    display: grid;
    grid-template-columns: 1fr 0.2fr 2fr 1fr 0.6fr;
    align-items: center;
    grid-column-gap: 10px;
    max-height: 56px;
}

.track-stock-pill-active .inventory-header-search-group-row-section:last-child .inventory-search-group-section:nth-child(3) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 10px;
}

.track-stock-pill-active .inventory-header-search-group-row-section:last-child .inventory-search-group-section:last-child {
    height: 56px;
    background: var(--call-to-action1) 0% 0% no-repeat padding-box;
    border-radius: 26px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font: normal normal bold 16px/19px Lato;
    letter-spacing: 0.16px;
    color: var(--neutral-color1);
    transition: all 0.5s;
}

.track-stock-pill-active .inventory-header-search-group-row-section:last-child .inventory-search-group-section:last-child:hover {
    background-color: var(--call-to-action2);
    transition: all 0.5s;
}

/* ------- New Track Stcok header ------ */
.track-scock-header-search-group-row-section {
    display: grid;
    grid-template-columns: 0.8fr 0.1fr 1.5fr 0.8fr 0.8fr 0.5fr;
    grid-column-gap: 7px;
    align-items: center;
}

.track-scock-header-search-group-row-section .inventory-search-group-section:nth-child(3) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 7px;
}


/* ----- Body Section ------- */
.wrapper-body-content-section {
    display: grid;
    grid-row-gap: 8px;
}

/* --- Filter section --- */
.inventory-filter-section {
    display: grid;
    grid-template-columns: 1fr 2fr 1fr;
    align-items: center;
}

.inventory-filter-section .filter-item-info-section {
    font: normal normal 20px/24px Lato;
    letter-spacing: 0.2px;
    color: var(--neutral-color6);
}

.inventory-filter-section .filter-item-info-section strong {
    color: var(--neutral-color7);
}

.inventory-filter-section .filter-item-info-section:nth-child(2) {
    display: grid;
    align-items: center;
    justify-items: center;
}

.inventory-filter-section .filter-item-info-section:last-child {
    font: normal normal 16px/19px Lato;
    letter-spacing: 0.16px;
    color: var(--neutral-color6);
    text-align: end;
    display: flex;
    justify-content: space-around;
    align-items: center;
    cursor: default;
}
.inventory-filter-section .filter-item-info-section:last-child .filter-item-info-group{
    display: flex;
    column-gap: 10px;
    cursor: pointer;
    align-items: center;
}
.inventory-filter-section .filter-item-info-section:last-child .filter-item-info-group .filter-item-ingo-content{
    color: var(--call-to-action1);
}
.inventory-filter-section .filter-item-info-section:last-child .filter-item-info-group:hover .filter-item-ingo-content{
    color: var(--call-to-action2);
}
.inventory-filter-section .filter-item-info-section:last-child .filter-item-info-group:hover svg path{
    fill: var(--call-to-action2);
    stroke: var(--call-to-action2);
}

/* Manage stock Card */
.manage-stock-card-section {
    min-height: 62px;
    width: 100%;
    background: var(--neutral-color1) 0% 0% no-repeat padding-box;
    box-shadow: 0px 0px 6px #00000029;
    border-radius: 6px;
    padding: 9px 14px 9px 24px;
    transition: all 0.5s;
}

.manage-stock-card-section:hover {
    transform: scale(1.012);
    transition: all 0.5s;
}

.wrapper-manage-stock-card-section {
    width: 100%;
    height: 100%;
    display: grid;
    grid-template-columns: 1fr 5fr 0fr;
    grid-column-gap: 20px;
    align-items: center;
}

.wrapper-manage-stock-card-section .normal-card-item-section {
    height: 100%;
    display: grid;
    align-items: center;
}

.wrapper-manage-stock-card-section .normal-card-item-section:first-child {
    border-right: 1px solid var(--neutral-color3);
}

.wrapper-manage-stock-card-section .normal-card-item-section:first-child .card-item-value {
    font: normal normal bold 18px/22px Lato;
    letter-spacing: 0.18px;
    color: var(--call-to-action1);
}

.wrapper-manage-stock-card-section .normal-card-item-section:nth-child(2) {
    display: grid;
    grid-template-columns: 3fr repeat(5, 1fr);
    column-gap: 10px;
     /* border-right: 1px solid var(--neutral-color3); */
    align-items: flex-start;
}

.wrapper-manage-stock-card-section .normal-card-item-section:last-child {
    transition: all 1s;

    /* padding: 5px; */
}

.wrapper-manage-stock-card-section .normal-card-item-section:last-child .normal-card-item-btn-section {
    min-height: 35px;
    background: var(--call-to-action3) 0% 0% no-repeat padding-box;
    border-radius: 18px;
    font: normal normal bold 14px/17px Lato;
    letter-spacing: 0.14px;
    color: var(--neutral-color1);
    text-transform: capitalize;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.5s;
    animation: fadeIn1 0.5s auto;
    margin-top: auto;
    margin-bottom: auto;
    padding: 5px 10px;
    text-align: center;
}
.wrapper-manage-stock-card-section .normal-card-item-section:last-child .normal-card-item-btn-section span{
    
}

.wrapper-manage-stock-card-section .normal-card-item-section:last-child .normal-card-item-btn-section.active-card-item-btn-section {
    background-color: var(--call-to-action1);
}

.wrapper-manage-stock-card-section .normal-card-item-section:last-child .normal-card-item-btn-section svg {
    margin-right: 5px;
}

.wrapper-manage-stock-card-section .normal-card-item-section:last-child .normal-card-item-btn-section.active-card-item-btn-section:hover {
    background-color: var(--call-to-action2);
}

.request-stock-card-active .normal-card-item-section:last-child .normal-card-item-btn-section.active-card-item-btn-section {
    animation: fadeIn 0.5s auto;
    transition: all 0.5s;
}

.request-stock-card-active {
    grid-template-columns: 1fr 3.5fr 1.5fr;
}

.request-stock-card-active .normal-card-item-section:nth-child(2) {
    grid-template-columns: 2fr repeat(3, 1fr);
    grid-column-gap: 5px;
}

.request-stock-card-active .normal-card-item-section:last-child .normal-card-item-inner-section {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 15px;
}

.request-stock-card-active .normal-card-item-section:last-child .normal-card-item-inner-section .card-item-qnt-section {
    display: grid;
    grid-template-columns: 1fr 3fr 1fr;
}

.request-stock-card-active .normal-card-item-section:last-child .normal-card-item-inner-section .card-item-qnt-section .card-item-qnt-input {
    width: 100%;
    min-height: 28px;
    background: var(--neutral-color1) 0% 0% no-repeat padding-box;
    border: 1px solid var(--neutral-color5);
    text-align: center;
    font: normal normal bold 14px/15px Lato;
    letter-spacing: 0.14px;
    color: var(--text-color2);
}

.request-stock-card-active .normal-card-item-section:last-child .normal-card-item-inner-section .card-item-qnt-section .card-item-qnt-btn {
    width: 100%;
    background: var(--neutral-color1) 0% 0% no-repeat padding-box;
    border: 1px solid var(--neutral-color5);
    border-radius: 4px 0px 0px 4px;
    display: grid;
    align-items: center;
    justify-items: center;
    cursor: pointer;
}

.request-stock-card-active .normal-card-item-section:last-child .normal-card-item-inner-section .card-item-qnt-section .card-item-qnt-btn:first-child {
    border-right: 0;
}

.request-stock-card-active .normal-card-item-section:last-child .normal-card-item-inner-section .card-item-qnt-section .card-item-qnt-btn:last-child {
    border-radius: 0px 4px 4px 0px;
    border-left: 0;
}

.request-stock-card-active .normal-card-item-section:last-child .normal-card-item-inner-section .normal-card-item-qnt-title {
    font: normal normal 12px/18px Lato;
    letter-spacing: 0.12px;
    color: var(--text-color1);
    text-align: center;
}




/* Track stock Card */
.track-stock-card-section {
    min-height: 62px;
    width: 100%;
    background: var(--neutral-color1) 0% 0% no-repeat padding-box;
    box-shadow: 0px 0px 6px var(--border-shadow-color2);
    border-radius: 6px;
    padding: 9px 14px 9px 24px;
    transition: all 0.5s;
}

.track-stock-card-section:hover {
    transform: scale(1.012);
    transition: all 0.5s;
}

.wrapper-track-stock-card-section {
    width: 100%;
    height: 100%;
    display: grid;
    grid-template-columns: 1fr 5fr;
    grid-column-gap: 20px;
    align-items: center;
}

.wrapper-track-stock-card-section .normal-card-item-section {
    height: 100%;
    display: grid;
    align-items: flex-start;
    padding: 5px;
}

.wrapper-track-stock-card-section .normal-card-item-section:first-child {
    border-right: 1px solid var(--neutral-color3);
}

.wrapper-track-stock-card-section .normal-card-item-section:first-child .card-item-value {
    font: normal normal bold 18px/22px Lato;
    letter-spacing: 0.18px;
    color: var(--call-to-action1);
}

.wrapper-track-stock-card-section .normal-card-item-section:nth-child(2) {
    display: grid;
    grid-template-columns: repeat(6, 1fr) 0.1fr;
    grid-column-gap: 10px;
    align-items: flex-start;
}

.wrapper-track-stock-card-section .normal-card-item-section:last-child {
    transition: all 1s;
    padding: 5px;
}

.wrapper-track-stock-card-section .normal-card-item-section .card-item-group {
    cursor: default;
}

.wrapper-track-stock-card-section .normal-card-item-section:last-child .normal-card-item-btn-section {
    height: 100%;
    width: 100%;
    display: grid;
    justify-items: end;
    align-items: center;
}

.wrapper-body-content-section .inventory-status-green .card-item-group:nth-child(6) .card-item-value.status-green {
    color: var(--indicators-green);
}
.wrapper-body-content-section .inventory-status-green .card-item-group:nth-child(6) .card-item-value.status-yellow {
    color: var(--indicators-yellow);
}

.wrapper-body-content-section .inventory-status-green .card-item-group:nth-child(6) .card-item-value.status-red {
    color: var(--indicators-red);
}

.wrapper-body-content-section .inventory-status-red .card-item-group:nth-child(6) .card-item-value {
    color: var(--indicators-red);
}

.item-moved-to-cart-card {
    font: normal normal 12px/19px Lato;
    letter-spacing: 0.12px;
    color: var(--neutral-color1);
    padding: 0 5px;
    border-radius: 6px;
    margin-top: -0.8rem;
    position: absolute;
    background-color: var(--indicators-green);
}

.track-scock-header-search-group-row-section.active-tracnsfer-stock{
    grid-template-columns: 0.8fr 0.1fr 1.5fr 0.8fr 0.5fr;
}

/* --------- Mobile Design ----------- */
@media screen and (max-width:992px) {
    :root {
        --inventory-bannder-height: 500px;
        --pill-height: 46px;
    }

    .wrapper-inventory-header-search-group {
        min-height: auto;
        padding: 0;
        background: transparent;
        box-shadow: none;
        color: var(--neutral-color1);
        grid-template-columns: 1fr;
        grid-row-gap: 10px;
    }

    .wrapper-inventory-header-search-group .inventory-header-search-group-row-section:first-child,
    .wrapper-inventory-header-search-group .inventory-header-search-group-row-section:first-child {
        display: grid;
        /* grid-template-columns: 1fr; */
        grid-row-gap: 15px;
        margin-bottom: 15px;
    }

    .track-stock-pill-active .inventory-header-search-group-row-section:last-child .inventory-search-group-section:nth-child(3) {
        grid-template-columns: 1fr;
        grid-row-gap: 15px;
    }

    .wrapper-inventory-header-search-group .inventory-header-search-group-row-section:last-child {
        max-height: none;
        text-align: center;
    }

    .wrapper-inventory-header-search-group .inventory-header-search-group-row-section:first-child .inventory-header-search-inner-group:first-child {
        grid-column-start: 1;
        grid-column-end: 3;
    }

    .wrapper-inventory-header-search-group .inventory-header-search-group-row-section:last-child {
        grid-template-columns: 1fr;
        color: var(--neutral-color4);
        grid-row-gap: 20px;
    }

    .wrapper-inventory-header-search-group .form-group {
        background-color: var(--neutral-color1);
        border-radius: 6px;
    }

    .wrapper-inventory-header-search-group .inventory-header-search-group-row-section:last-child label {
        color: var(--neutral-color5);
    }

    .wrapper-inventory-header-search-group .inventory-header-search-group-row-section:last-child .inventory-search-group-section:last-child {
        margin-top: 10px;
    }

    .track-scock-header-search-group-row-section {
        margin-top: 5px;
        grid-template-columns: 1fr;
        grid-row-gap: 10px;
    }

    .track-scock-header-search-group-row-section label {
        color: var(--neutral-color6);
    }

    .track-scock-header-search-group-row-section .inventory-search-group-section:nth-child(3) {
        grid-template-columns: 1fr;
        grid-row-gap: 10px;
    }

    .inventory-filter-section {
        grid-template-columns: 1fr;
        grid-row-gap: 10px;
    }

    .inventory-filter-section .filter-item-info-section:last-child {
        text-align: center;
    }

    /* ---- Card ------ */
    .manage-stock-card-section {
        /* min-height: 350px; */
        padding-bottom: 10px;
    }

    .wrapper-manage-stock-card-section {
        grid-template-columns: 1fr;
        grid-template-rows: 1fr 6fr 1fr;
    }

    .request-stock-card-active {
        grid-template-rows: 1fr 4fr 2.5fr;
    }

    .wrapper-manage-stock-card-section .normal-card-item-section:first-child {
        border-right: 0;
        border-bottom: 1px solid var(--neutral-color4);
    }

    .wrapper-manage-stock-card-section .normal-card-item-section:first-child .card-item-group {
        display: grid;
        grid-template-columns: 0.7fr 1fr;
        align-items: center;
    }

    .wrapper-manage-stock-card-section .normal-card-item-section:nth-child(2) {
        grid-template-columns: 1fr;
        border-right: 0;
        padding-top: 10px;
    }

    .wrapper-manage-stock-card-section .normal-card-item-section:nth-child(2) .card-item-group {
        display: grid;
        grid-template-columns: 0.5fr 1fr;
        column-gap: 10px;
    }

    .wrapper-manage-stock-card-section .normal-card-item-section:last-child .normal-card-item-inner-section {
        grid-template-columns: 1fr;
        grid-template-rows: 1.2fr 1fr;
        grid-row-gap: 15px;
        height: 100%;
    }

    .wrapper-manage-stock-card-section .normal-card-item-section:last-child .normal-card-item-inner-section .normal-card-item-add-qnt-section {
        display: grid;
        grid-template-columns: 0.5fr 1fr;
        text-align: start;
        justify-items: self-start;
        padding-right: 10px;
        align-items: center;
        padding-bottom: 10px;
        min-height: 50px;
        border-bottom: 1px solid var(--neutral-color4);
    }

    .wrapper-manage-stock-card-section .normal-card-item-section:last-child .normal-card-item-inner-section .normal-card-item-btn-section {
        height: 100%;
    }

    .request-stock-card-active .normal-card-item-section:last-child .normal-card-item-inner-section .card-item-qnt-section {
        height: 100%;
    }


    /* -------- Track Stock ---------- */
    .inventory-filter-section .filter-item-info-section {
        font: normal normal 16px/19px Lato;
        letter-spacing: 0.16px;
    }

    .track-stock-card-section {
        min-height: auto;
    }

    .wrapper-track-stock-card-section {
        grid-template-columns: 1fr;
        position: relative;
    }

    .wrapper-track-stock-card-section .normal-card-item-section:first-child {
        border-bottom: 1px solid var(--neutral-color4);
        border-right: transparent;
        padding-bottom: 10px;
    }

    .wrapper-track-stock-card-section .normal-card-item-section:last-child {
        grid-template-columns: 1fr;
        grid-row-gap: 10px;
    }

    .wrapper-track-stock-card-section .normal-card-item-section:last-child .card-item-group {
        display: grid;
        grid-template-columns: 0.5fr 1fr;
        grid-column-gap: 15px;
    }

    .wrapper-track-stock-card-section .normal-card-item-section:last-child .normal-card-item-btn-section {
        position: absolute;
        top: 12px;
        right: 0;
        height: auto;
        width: auto;
        padding: 5px;
    }
}`, "",{"version":3,"sources":["webpack://./src/Assets/CSS/InventoryPage.css"],"names":[],"mappings":"AAAA;IACI,iCAAiC;AACrC;;AAEA;IACI,2CAA2C;IAC3C,sDAAsD;IACtD,4BAA4B;IAC5B,WAAW;AACf;;AAEA;IACI,WAAW;IACX,2CAA2C;IAC3C,mCAAmC;AACvC;;AAEA;;IAEI,yDAAyD;AAC7D;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,WAAW;IACX,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,6DAA6D;IAC7D,kBAAkB;IAClB,mDAAmD;IACnD,uBAAuB;IACvB,aAAa;IACb,oBAAoB;IACpB,kBAAkB;IAClB,4BAA4B;AAChC;;AAEA;IACI;yCACqC;IACrC,aAAa;IACb,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,sCAAsC;IACtC,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,kCAAkC;IAClC,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,kDAAkD;IAClD,mBAAmB;IACnB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,8DAA8D;IAC9D,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,uCAAuC;IACvC,sBAAsB;IACtB,4BAA4B;IAC5B,oBAAoB;AACxB;;AAEA;IACI,wCAAwC;IACxC,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;AACtB;;;;AAIA;IACI,aAAa;IACb,8CAA8C;IAC9C,mBAAmB;IACnB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,8DAA8D;IAC9D,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,uCAAuC;IACvC,sBAAsB;IACtB,4BAA4B;IAC5B,oBAAoB;AACxB;;AAEA;IACI,wCAAwC;IACxC,oBAAoB;AACxB;;AAEA,0CAA0C;AAC1C;IACI,aAAa;IACb,0DAA0D;IAC1D,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,oBAAoB;AACxB;;;AAGA,+BAA+B;AAC/B;IACI,aAAa;IACb,iBAAiB;AACrB;;AAEA,2BAA2B;AAC3B;IACI,aAAa;IACb,kCAAkC;IAClC,mBAAmB;AACvB;;AAEA;IACI,kCAAkC;IAClC,qBAAqB;IACrB,4BAA4B;AAChC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,kCAAkC;IAClC,sBAAsB;IACtB,4BAA4B;IAC5B,eAAe;IACf,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,6BAA6B;AACjC;AACA;IACI,6BAA6B;AACjC;AACA;IACI,4BAA4B;IAC5B,8BAA8B;AAClC;;AAEA,sBAAsB;AACtB;IACI,gBAAgB;IAChB,WAAW;IACX,6DAA6D;IAC7D,iCAAiC;IACjC,kBAAkB;IAClB,0BAA0B;IAC1B,oBAAoB;AACxB;;AAEA;IACI,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,kCAAkC;IAClC,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,uCAAuC;IACvC,sBAAsB;IACtB,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,yCAAyC;IACzC,gBAAgB;KACf,mDAAmD;IACpD,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;;IAElB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,8DAA8D;IAC9D,mBAAmB;IACnB,uCAAuC;IACvC,sBAAsB;IACtB,4BAA4B;IAC5B,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,oBAAoB;IACpB,4BAA4B;IAC5B,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;AACtB;AACA;;AAEA;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,2BAA2B;IAC3B,oBAAoB;AACxB;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,yCAAyC;IACzC,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,kCAAkC;AACtC;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,6DAA6D;IAC7D,uCAAuC;IACvC,kBAAkB;IAClB,uCAAuC;IACvC,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,6DAA6D;IAC7D,uCAAuC;IACvC,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,8BAA8B;IAC9B,cAAc;AAClB;;AAEA;IACI,kCAAkC;IAClC,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;AACtB;;;;;AAKA,qBAAqB;AACrB;IACI,gBAAgB;IAChB,WAAW;IACX,6DAA6D;IAC7D,mDAAmD;IACnD,kBAAkB;IAClB,0BAA0B;IAC1B,oBAAoB;AACxB;;AAEA;IACI,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,uCAAuC;IACvC,sBAAsB;IACtB,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,2CAA2C;IAC3C,qBAAqB;IACrB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;AACA;IACI,+BAA+B;AACnC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,kCAAkC;IAClC,sBAAsB;IACtB,4BAA4B;IAC5B,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,yCAAyC;AAC7C;;AAEA;IACI,oDAAoD;AACxD;;AAEA,wCAAwC;AACxC;IACI;QACI,iCAAiC;QACjC,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;QAChB,UAAU;QACV,uBAAuB;QACvB,gBAAgB;QAChB,4BAA4B;QAC5B,0BAA0B;QAC1B,kBAAkB;IACtB;;IAEA;;QAEI,aAAa;QACb,gCAAgC;QAChC,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,0BAA0B;QAC1B,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,oBAAoB;QACpB,kBAAkB;IACtB;;IAEA;QACI,0BAA0B;QAC1B,4BAA4B;QAC5B,kBAAkB;IACtB;;IAEA;QACI,uCAAuC;QACvC,kBAAkB;IACtB;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,0BAA0B;QAC1B,kBAAkB;IACtB;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,0BAA0B;QAC1B,kBAAkB;IACtB;;IAEA;QACI,0BAA0B;QAC1B,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;IACtB;;IAEA,qBAAqB;IACrB;QACI,uBAAuB;QACvB,oBAAoB;IACxB;;IAEA;QACI,0BAA0B;QAC1B,+BAA+B;IACnC;;IAEA;QACI,iCAAiC;IACrC;;IAEA;QACI,eAAe;QACf,8CAA8C;IAClD;;IAEA;QACI,aAAa;QACb,gCAAgC;QAChC,mBAAmB;IACvB;;IAEA;QACI,0BAA0B;QAC1B,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,aAAa;QACb,gCAAgC;QAChC,gBAAgB;IACpB;;IAEA;QACI,0BAA0B;QAC1B,6BAA6B;QAC7B,kBAAkB;QAClB,YAAY;IAChB;;IAEA;QACI,aAAa;QACb,gCAAgC;QAChC,iBAAiB;QACjB,yBAAyB;QACzB,mBAAmB;QACnB,mBAAmB;QACnB,oBAAoB;QACpB,gBAAgB;QAChB,8CAA8C;IAClD;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,YAAY;IAChB;;;IAGA,oCAAoC;IACpC;QACI,kCAAkC;QAClC,sBAAsB;IAC1B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,0BAA0B;QAC1B,kBAAkB;IACtB;;IAEA;QACI,8CAA8C;QAC9C,yBAAyB;QACzB,oBAAoB;IACxB;;IAEA;QACI,0BAA0B;QAC1B,kBAAkB;IACtB;;IAEA;QACI,aAAa;QACb,gCAAgC;QAChC,qBAAqB;IACzB;;IAEA;QACI,kBAAkB;QAClB,SAAS;QACT,QAAQ;QACR,YAAY;QACZ,WAAW;QACX,YAAY;IAChB;AACJ","sourcesContent":[":root {\r\n    --inventory-bannder-height: 300px;\r\n}\r\n\r\n.inventory-header-start-section {\r\n    min-height: var(--inventory-bannder-height);\r\n    background: var(--bg-blue) 0% 0% no-repeat padding-box;\r\n    color: var(--neutral-color1);\r\n    width: 100%;\r\n}\r\n\r\n.wrapper-inventory-header-section {\r\n    width: 100%;\r\n    min-height: var(--inventory-bannder-height);\r\n    padding: var(--body-header-padding);\r\n}\r\n\r\n.admin-inventory-header-start-section,\r\n.admin-inventory-header-start-section .wrapper-inventory-header-section {\r\n    min-height: calc(var(--inventory-bannder-height) - 100px);\r\n}\r\n\r\n.mutebtn{\r\n    background-color: #A6D5EA !important;\r\n}\r\n\r\n.inventory-header-pill-section {\r\n    width: 100%;\r\n    display: grid;\r\n    justify-items: center;\r\n}\r\n\r\n.inventory-header-pill-section .nav-responsive {\r\n    max-width: 300px;\r\n}\r\n\r\n.inventory-header-search-group-section {\r\n    width: 100%;\r\n    height: 100%;\r\n    display: flex;\r\n    justify-content: center;\r\n    margin-top: 20px;\r\n}\r\n\r\n.wrapper-inventory-header-search-group {\r\n    min-height: 142px;\r\n    background: var(--neutral-color1) 0% 0% no-repeat padding-box;\r\n    border-radius: 6px;\r\n    box-shadow: 0px 0px 6px var(--border-shadow-color3);\r\n    padding: 18px 31px 21px;\r\n    display: grid;\r\n    transition: all 0.7s;\r\n    grid-row-gap: 10px;\r\n    color: var(--neutral-color7);\r\n}\r\n\r\n.wrapper-inventory-header-search-group .inventory-header-search-group-row-section:first-child {\r\n    /* display: grid;\r\n    grid-template-columns: 2fr 2fr 5fr; */\r\n    display: flex;\r\n    column-gap: 20px;\r\n    align-items: center;\r\n}\r\n\r\n.wrapper-inventory-header-search-group .inventory-header-search-group-row-section:first-child .inventory-header-search-inner-group:first-child {\r\n    font: normal normal 300 26px/32px Lato;\r\n    letter-spacing: 0.26px;\r\n    cursor: default;\r\n}\r\n\r\n.wrapper-inventory-header-search-group .inventory-header-search-group-row-section:first-child .inventory-header-search-inner-group .custom-control-label {\r\n    font: normal normal 14px/17px Lato;\r\n    letter-spacing: 0.14px;\r\n}\r\n\r\n.wrapper-inventory-header-search-group .inventory-header-search-group-row-section:first-child .inventory-header-search-inner-group .custom-control {\r\n    display: grid;\r\n    align-items: center;\r\n}\r\n\r\n.wrapper-inventory-header-search-group .inventory-header-search-group-row-section:last-child {\r\n    display: grid;\r\n    grid-template-columns: 1.4fr 1.2fr 0.1fr 2.4fr 1fr;\r\n    align-items: center;\r\n    grid-column-gap: 10px;\r\n    max-height: 56px;\r\n}\r\n\r\n.wrapper-inventory-header-search-group .inventory-header-search-group-row-section:last-child .inventory-search-group-section:last-child {\r\n    height: 56px;\r\n    background: var(--call-to-action1) 0% 0% no-repeat padding-box;\r\n    border-radius: 26px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    cursor: pointer;\r\n    font: normal normal bold 16px/19px Lato;\r\n    letter-spacing: 0.16px;\r\n    color: var(--neutral-color1);\r\n    transition: all 0.5s;\r\n}\r\n\r\n.wrapper-inventory-header-search-group .inventory-header-search-group-row-section:last-child .inventory-search-group-section:last-child:hover {\r\n    background-color: var(--call-to-action2);\r\n    transition: all 0.5s;\r\n}\r\n\r\n.wrapper-inventory-header-search-group .inventory-header-search-group-row-section:last-child .inventory-search-group-section:last-child svg {\r\n    margin-right: 10px;\r\n}\r\n\r\n\r\n\r\n.track-stock-pill-active .inventory-header-search-group-row-section:last-child {\r\n    display: grid;\r\n    grid-template-columns: 1fr 0.2fr 2fr 1fr 0.6fr;\r\n    align-items: center;\r\n    grid-column-gap: 10px;\r\n    max-height: 56px;\r\n}\r\n\r\n.track-stock-pill-active .inventory-header-search-group-row-section:last-child .inventory-search-group-section:nth-child(3) {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-column-gap: 10px;\r\n}\r\n\r\n.track-stock-pill-active .inventory-header-search-group-row-section:last-child .inventory-search-group-section:last-child {\r\n    height: 56px;\r\n    background: var(--call-to-action1) 0% 0% no-repeat padding-box;\r\n    border-radius: 26px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    cursor: pointer;\r\n    font: normal normal bold 16px/19px Lato;\r\n    letter-spacing: 0.16px;\r\n    color: var(--neutral-color1);\r\n    transition: all 0.5s;\r\n}\r\n\r\n.track-stock-pill-active .inventory-header-search-group-row-section:last-child .inventory-search-group-section:last-child:hover {\r\n    background-color: var(--call-to-action2);\r\n    transition: all 0.5s;\r\n}\r\n\r\n/* ------- New Track Stcok header ------ */\r\n.track-scock-header-search-group-row-section {\r\n    display: grid;\r\n    grid-template-columns: 0.8fr 0.1fr 1.5fr 0.8fr 0.8fr 0.5fr;\r\n    grid-column-gap: 7px;\r\n    align-items: center;\r\n}\r\n\r\n.track-scock-header-search-group-row-section .inventory-search-group-section:nth-child(3) {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-column-gap: 7px;\r\n}\r\n\r\n\r\n/* ----- Body Section ------- */\r\n.wrapper-body-content-section {\r\n    display: grid;\r\n    grid-row-gap: 8px;\r\n}\r\n\r\n/* --- Filter section --- */\r\n.inventory-filter-section {\r\n    display: grid;\r\n    grid-template-columns: 1fr 2fr 1fr;\r\n    align-items: center;\r\n}\r\n\r\n.inventory-filter-section .filter-item-info-section {\r\n    font: normal normal 20px/24px Lato;\r\n    letter-spacing: 0.2px;\r\n    color: var(--neutral-color6);\r\n}\r\n\r\n.inventory-filter-section .filter-item-info-section strong {\r\n    color: var(--neutral-color7);\r\n}\r\n\r\n.inventory-filter-section .filter-item-info-section:nth-child(2) {\r\n    display: grid;\r\n    align-items: center;\r\n    justify-items: center;\r\n}\r\n\r\n.inventory-filter-section .filter-item-info-section:last-child {\r\n    font: normal normal 16px/19px Lato;\r\n    letter-spacing: 0.16px;\r\n    color: var(--neutral-color6);\r\n    text-align: end;\r\n    display: flex;\r\n    justify-content: space-around;\r\n    align-items: center;\r\n    cursor: default;\r\n}\r\n.inventory-filter-section .filter-item-info-section:last-child .filter-item-info-group{\r\n    display: flex;\r\n    column-gap: 10px;\r\n    cursor: pointer;\r\n    align-items: center;\r\n}\r\n.inventory-filter-section .filter-item-info-section:last-child .filter-item-info-group .filter-item-ingo-content{\r\n    color: var(--call-to-action1);\r\n}\r\n.inventory-filter-section .filter-item-info-section:last-child .filter-item-info-group:hover .filter-item-ingo-content{\r\n    color: var(--call-to-action2);\r\n}\r\n.inventory-filter-section .filter-item-info-section:last-child .filter-item-info-group:hover svg path{\r\n    fill: var(--call-to-action2);\r\n    stroke: var(--call-to-action2);\r\n}\r\n\r\n/* Manage stock Card */\r\n.manage-stock-card-section {\r\n    min-height: 62px;\r\n    width: 100%;\r\n    background: var(--neutral-color1) 0% 0% no-repeat padding-box;\r\n    box-shadow: 0px 0px 6px #00000029;\r\n    border-radius: 6px;\r\n    padding: 9px 14px 9px 24px;\r\n    transition: all 0.5s;\r\n}\r\n\r\n.manage-stock-card-section:hover {\r\n    transform: scale(1.012);\r\n    transition: all 0.5s;\r\n}\r\n\r\n.wrapper-manage-stock-card-section {\r\n    width: 100%;\r\n    height: 100%;\r\n    display: grid;\r\n    grid-template-columns: 1fr 5fr 0fr;\r\n    grid-column-gap: 20px;\r\n    align-items: center;\r\n}\r\n\r\n.wrapper-manage-stock-card-section .normal-card-item-section {\r\n    height: 100%;\r\n    display: grid;\r\n    align-items: center;\r\n}\r\n\r\n.wrapper-manage-stock-card-section .normal-card-item-section:first-child {\r\n    border-right: 1px solid var(--neutral-color3);\r\n}\r\n\r\n.wrapper-manage-stock-card-section .normal-card-item-section:first-child .card-item-value {\r\n    font: normal normal bold 18px/22px Lato;\r\n    letter-spacing: 0.18px;\r\n    color: var(--call-to-action1);\r\n}\r\n\r\n.wrapper-manage-stock-card-section .normal-card-item-section:nth-child(2) {\r\n    display: grid;\r\n    grid-template-columns: 3fr repeat(5, 1fr);\r\n    column-gap: 10px;\r\n     /* border-right: 1px solid var(--neutral-color3); */\r\n    align-items: flex-start;\r\n}\r\n\r\n.wrapper-manage-stock-card-section .normal-card-item-section:last-child {\r\n    transition: all 1s;\r\n\r\n    /* padding: 5px; */\r\n}\r\n\r\n.wrapper-manage-stock-card-section .normal-card-item-section:last-child .normal-card-item-btn-section {\r\n    min-height: 35px;\r\n    background: var(--call-to-action3) 0% 0% no-repeat padding-box;\r\n    border-radius: 18px;\r\n    font: normal normal bold 14px/17px Lato;\r\n    letter-spacing: 0.14px;\r\n    color: var(--neutral-color1);\r\n    text-transform: capitalize;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    cursor: pointer;\r\n    transition: all 0.5s;\r\n    animation: fadeIn1 0.5s auto;\r\n    margin-top: auto;\r\n    margin-bottom: auto;\r\n    padding: 5px 10px;\r\n    text-align: center;\r\n}\r\n.wrapper-manage-stock-card-section .normal-card-item-section:last-child .normal-card-item-btn-section span{\r\n    \r\n}\r\n\r\n.wrapper-manage-stock-card-section .normal-card-item-section:last-child .normal-card-item-btn-section.active-card-item-btn-section {\r\n    background-color: var(--call-to-action1);\r\n}\r\n\r\n.wrapper-manage-stock-card-section .normal-card-item-section:last-child .normal-card-item-btn-section svg {\r\n    margin-right: 5px;\r\n}\r\n\r\n.wrapper-manage-stock-card-section .normal-card-item-section:last-child .normal-card-item-btn-section.active-card-item-btn-section:hover {\r\n    background-color: var(--call-to-action2);\r\n}\r\n\r\n.request-stock-card-active .normal-card-item-section:last-child .normal-card-item-btn-section.active-card-item-btn-section {\r\n    animation: fadeIn 0.5s auto;\r\n    transition: all 0.5s;\r\n}\r\n\r\n.request-stock-card-active {\r\n    grid-template-columns: 1fr 3.5fr 1.5fr;\r\n}\r\n\r\n.request-stock-card-active .normal-card-item-section:nth-child(2) {\r\n    grid-template-columns: 2fr repeat(3, 1fr);\r\n    grid-column-gap: 5px;\r\n}\r\n\r\n.request-stock-card-active .normal-card-item-section:last-child .normal-card-item-inner-section {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-column-gap: 15px;\r\n}\r\n\r\n.request-stock-card-active .normal-card-item-section:last-child .normal-card-item-inner-section .card-item-qnt-section {\r\n    display: grid;\r\n    grid-template-columns: 1fr 3fr 1fr;\r\n}\r\n\r\n.request-stock-card-active .normal-card-item-section:last-child .normal-card-item-inner-section .card-item-qnt-section .card-item-qnt-input {\r\n    width: 100%;\r\n    min-height: 28px;\r\n    background: var(--neutral-color1) 0% 0% no-repeat padding-box;\r\n    border: 1px solid var(--neutral-color5);\r\n    text-align: center;\r\n    font: normal normal bold 14px/15px Lato;\r\n    letter-spacing: 0.14px;\r\n    color: var(--text-color2);\r\n}\r\n\r\n.request-stock-card-active .normal-card-item-section:last-child .normal-card-item-inner-section .card-item-qnt-section .card-item-qnt-btn {\r\n    width: 100%;\r\n    background: var(--neutral-color1) 0% 0% no-repeat padding-box;\r\n    border: 1px solid var(--neutral-color5);\r\n    border-radius: 4px 0px 0px 4px;\r\n    display: grid;\r\n    align-items: center;\r\n    justify-items: center;\r\n    cursor: pointer;\r\n}\r\n\r\n.request-stock-card-active .normal-card-item-section:last-child .normal-card-item-inner-section .card-item-qnt-section .card-item-qnt-btn:first-child {\r\n    border-right: 0;\r\n}\r\n\r\n.request-stock-card-active .normal-card-item-section:last-child .normal-card-item-inner-section .card-item-qnt-section .card-item-qnt-btn:last-child {\r\n    border-radius: 0px 4px 4px 0px;\r\n    border-left: 0;\r\n}\r\n\r\n.request-stock-card-active .normal-card-item-section:last-child .normal-card-item-inner-section .normal-card-item-qnt-title {\r\n    font: normal normal 12px/18px Lato;\r\n    letter-spacing: 0.12px;\r\n    color: var(--text-color1);\r\n    text-align: center;\r\n}\r\n\r\n\r\n\r\n\r\n/* Track stock Card */\r\n.track-stock-card-section {\r\n    min-height: 62px;\r\n    width: 100%;\r\n    background: var(--neutral-color1) 0% 0% no-repeat padding-box;\r\n    box-shadow: 0px 0px 6px var(--border-shadow-color2);\r\n    border-radius: 6px;\r\n    padding: 9px 14px 9px 24px;\r\n    transition: all 0.5s;\r\n}\r\n\r\n.track-stock-card-section:hover {\r\n    transform: scale(1.012);\r\n    transition: all 0.5s;\r\n}\r\n\r\n.wrapper-track-stock-card-section {\r\n    width: 100%;\r\n    height: 100%;\r\n    display: grid;\r\n    grid-template-columns: 1fr 5fr;\r\n    grid-column-gap: 20px;\r\n    align-items: center;\r\n}\r\n\r\n.wrapper-track-stock-card-section .normal-card-item-section {\r\n    height: 100%;\r\n    display: grid;\r\n    align-items: flex-start;\r\n    padding: 5px;\r\n}\r\n\r\n.wrapper-track-stock-card-section .normal-card-item-section:first-child {\r\n    border-right: 1px solid var(--neutral-color3);\r\n}\r\n\r\n.wrapper-track-stock-card-section .normal-card-item-section:first-child .card-item-value {\r\n    font: normal normal bold 18px/22px Lato;\r\n    letter-spacing: 0.18px;\r\n    color: var(--call-to-action1);\r\n}\r\n\r\n.wrapper-track-stock-card-section .normal-card-item-section:nth-child(2) {\r\n    display: grid;\r\n    grid-template-columns: repeat(6, 1fr) 0.1fr;\r\n    grid-column-gap: 10px;\r\n    align-items: flex-start;\r\n}\r\n\r\n.wrapper-track-stock-card-section .normal-card-item-section:last-child {\r\n    transition: all 1s;\r\n    padding: 5px;\r\n}\r\n\r\n.wrapper-track-stock-card-section .normal-card-item-section .card-item-group {\r\n    cursor: default;\r\n}\r\n\r\n.wrapper-track-stock-card-section .normal-card-item-section:last-child .normal-card-item-btn-section {\r\n    height: 100%;\r\n    width: 100%;\r\n    display: grid;\r\n    justify-items: end;\r\n    align-items: center;\r\n}\r\n\r\n.wrapper-body-content-section .inventory-status-green .card-item-group:nth-child(6) .card-item-value.status-green {\r\n    color: var(--indicators-green);\r\n}\r\n.wrapper-body-content-section .inventory-status-green .card-item-group:nth-child(6) .card-item-value.status-yellow {\r\n    color: var(--indicators-yellow);\r\n}\r\n\r\n.wrapper-body-content-section .inventory-status-green .card-item-group:nth-child(6) .card-item-value.status-red {\r\n    color: var(--indicators-red);\r\n}\r\n\r\n.wrapper-body-content-section .inventory-status-red .card-item-group:nth-child(6) .card-item-value {\r\n    color: var(--indicators-red);\r\n}\r\n\r\n.item-moved-to-cart-card {\r\n    font: normal normal 12px/19px Lato;\r\n    letter-spacing: 0.12px;\r\n    color: var(--neutral-color1);\r\n    padding: 0 5px;\r\n    border-radius: 6px;\r\n    margin-top: -0.8rem;\r\n    position: absolute;\r\n    background-color: var(--indicators-green);\r\n}\r\n\r\n.track-scock-header-search-group-row-section.active-tracnsfer-stock{\r\n    grid-template-columns: 0.8fr 0.1fr 1.5fr 0.8fr 0.5fr;\r\n}\r\n\r\n/* --------- Mobile Design ----------- */\r\n@media screen and (max-width:992px) {\r\n    :root {\r\n        --inventory-bannder-height: 500px;\r\n        --pill-height: 46px;\r\n    }\r\n\r\n    .wrapper-inventory-header-search-group {\r\n        min-height: auto;\r\n        padding: 0;\r\n        background: transparent;\r\n        box-shadow: none;\r\n        color: var(--neutral-color1);\r\n        grid-template-columns: 1fr;\r\n        grid-row-gap: 10px;\r\n    }\r\n\r\n    .wrapper-inventory-header-search-group .inventory-header-search-group-row-section:first-child,\r\n    .wrapper-inventory-header-search-group .inventory-header-search-group-row-section:first-child {\r\n        display: grid;\r\n        /* grid-template-columns: 1fr; */\r\n        grid-row-gap: 15px;\r\n        margin-bottom: 15px;\r\n    }\r\n\r\n    .track-stock-pill-active .inventory-header-search-group-row-section:last-child .inventory-search-group-section:nth-child(3) {\r\n        grid-template-columns: 1fr;\r\n        grid-row-gap: 15px;\r\n    }\r\n\r\n    .wrapper-inventory-header-search-group .inventory-header-search-group-row-section:last-child {\r\n        max-height: none;\r\n        text-align: center;\r\n    }\r\n\r\n    .wrapper-inventory-header-search-group .inventory-header-search-group-row-section:first-child .inventory-header-search-inner-group:first-child {\r\n        grid-column-start: 1;\r\n        grid-column-end: 3;\r\n    }\r\n\r\n    .wrapper-inventory-header-search-group .inventory-header-search-group-row-section:last-child {\r\n        grid-template-columns: 1fr;\r\n        color: var(--neutral-color4);\r\n        grid-row-gap: 20px;\r\n    }\r\n\r\n    .wrapper-inventory-header-search-group .form-group {\r\n        background-color: var(--neutral-color1);\r\n        border-radius: 6px;\r\n    }\r\n\r\n    .wrapper-inventory-header-search-group .inventory-header-search-group-row-section:last-child label {\r\n        color: var(--neutral-color5);\r\n    }\r\n\r\n    .wrapper-inventory-header-search-group .inventory-header-search-group-row-section:last-child .inventory-search-group-section:last-child {\r\n        margin-top: 10px;\r\n    }\r\n\r\n    .track-scock-header-search-group-row-section {\r\n        margin-top: 5px;\r\n        grid-template-columns: 1fr;\r\n        grid-row-gap: 10px;\r\n    }\r\n\r\n    .track-scock-header-search-group-row-section label {\r\n        color: var(--neutral-color6);\r\n    }\r\n\r\n    .track-scock-header-search-group-row-section .inventory-search-group-section:nth-child(3) {\r\n        grid-template-columns: 1fr;\r\n        grid-row-gap: 10px;\r\n    }\r\n\r\n    .inventory-filter-section {\r\n        grid-template-columns: 1fr;\r\n        grid-row-gap: 10px;\r\n    }\r\n\r\n    .inventory-filter-section .filter-item-info-section:last-child {\r\n        text-align: center;\r\n    }\r\n\r\n    /* ---- Card ------ */\r\n    .manage-stock-card-section {\r\n        /* min-height: 350px; */\r\n        padding-bottom: 10px;\r\n    }\r\n\r\n    .wrapper-manage-stock-card-section {\r\n        grid-template-columns: 1fr;\r\n        grid-template-rows: 1fr 6fr 1fr;\r\n    }\r\n\r\n    .request-stock-card-active {\r\n        grid-template-rows: 1fr 4fr 2.5fr;\r\n    }\r\n\r\n    .wrapper-manage-stock-card-section .normal-card-item-section:first-child {\r\n        border-right: 0;\r\n        border-bottom: 1px solid var(--neutral-color4);\r\n    }\r\n\r\n    .wrapper-manage-stock-card-section .normal-card-item-section:first-child .card-item-group {\r\n        display: grid;\r\n        grid-template-columns: 0.7fr 1fr;\r\n        align-items: center;\r\n    }\r\n\r\n    .wrapper-manage-stock-card-section .normal-card-item-section:nth-child(2) {\r\n        grid-template-columns: 1fr;\r\n        border-right: 0;\r\n        padding-top: 10px;\r\n    }\r\n\r\n    .wrapper-manage-stock-card-section .normal-card-item-section:nth-child(2) .card-item-group {\r\n        display: grid;\r\n        grid-template-columns: 0.5fr 1fr;\r\n        column-gap: 10px;\r\n    }\r\n\r\n    .wrapper-manage-stock-card-section .normal-card-item-section:last-child .normal-card-item-inner-section {\r\n        grid-template-columns: 1fr;\r\n        grid-template-rows: 1.2fr 1fr;\r\n        grid-row-gap: 15px;\r\n        height: 100%;\r\n    }\r\n\r\n    .wrapper-manage-stock-card-section .normal-card-item-section:last-child .normal-card-item-inner-section .normal-card-item-add-qnt-section {\r\n        display: grid;\r\n        grid-template-columns: 0.5fr 1fr;\r\n        text-align: start;\r\n        justify-items: self-start;\r\n        padding-right: 10px;\r\n        align-items: center;\r\n        padding-bottom: 10px;\r\n        min-height: 50px;\r\n        border-bottom: 1px solid var(--neutral-color4);\r\n    }\r\n\r\n    .wrapper-manage-stock-card-section .normal-card-item-section:last-child .normal-card-item-inner-section .normal-card-item-btn-section {\r\n        height: 100%;\r\n    }\r\n\r\n    .request-stock-card-active .normal-card-item-section:last-child .normal-card-item-inner-section .card-item-qnt-section {\r\n        height: 100%;\r\n    }\r\n\r\n\r\n    /* -------- Track Stock ---------- */\r\n    .inventory-filter-section .filter-item-info-section {\r\n        font: normal normal 16px/19px Lato;\r\n        letter-spacing: 0.16px;\r\n    }\r\n\r\n    .track-stock-card-section {\r\n        min-height: auto;\r\n    }\r\n\r\n    .wrapper-track-stock-card-section {\r\n        grid-template-columns: 1fr;\r\n        position: relative;\r\n    }\r\n\r\n    .wrapper-track-stock-card-section .normal-card-item-section:first-child {\r\n        border-bottom: 1px solid var(--neutral-color4);\r\n        border-right: transparent;\r\n        padding-bottom: 10px;\r\n    }\r\n\r\n    .wrapper-track-stock-card-section .normal-card-item-section:last-child {\r\n        grid-template-columns: 1fr;\r\n        grid-row-gap: 10px;\r\n    }\r\n\r\n    .wrapper-track-stock-card-section .normal-card-item-section:last-child .card-item-group {\r\n        display: grid;\r\n        grid-template-columns: 0.5fr 1fr;\r\n        grid-column-gap: 15px;\r\n    }\r\n\r\n    .wrapper-track-stock-card-section .normal-card-item-section:last-child .normal-card-item-btn-section {\r\n        position: absolute;\r\n        top: 12px;\r\n        right: 0;\r\n        height: auto;\r\n        width: auto;\r\n        padding: 5px;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
